<template>
  <div class="help-modal">
    <div class="help-content">
      <img src="/icons/pay-help-close.svg" class="close-icon" @click="$emit('close')">
      <div id="gatewayHelpImages">
        <!-- <div class="left-spacer"></div> -->
        <img
          v-for="s in totalSteps"
          :key="s"
          :class="{
              'help-image': true,
              'help-image-current': step == s-1
            }"
          :src="`/img/gateways/${gateway}_guide_${s}.png`"
        />
        <!-- <div class="left-spacer"></div> -->
      </div>
      <div class="help-text c-white iqos-group-item">
        {{ step + 1 }}. {{ $t(`online_payment.help.${gateway}.${step}`) }}
      </div>
      <div class="help-controls">
        <SystemsNavigator
          :elements_count="totalSteps"
          @left="changeStep(-1)"
          @right="changeStep(1)"
          :id="'gatewayHelpImages'"
          :bias="25"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";

import SystemsNavigator from "@/components/SystemsNavigator.vue";

export default {
  props: {
    gateway: String,
  },
  data() {
    return {
      step: 0,
    };
  },
  computed: {
    totalSteps() {
      const values = {
        liqpay: 5,
        wayforpay: 5,
        yookassa: 3,
        stripe: 5
      };

      return values[this.gateway];
    },
  },
  methods: {
    changeStep(delta) {
      if (this.step > 0 && delta < 0) this.step += delta;
      if (this.step < this.totalSteps-1 && delta > 0) this.step += delta;
    },
  },
  mounted() {
    window.document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    window.document.body.style.overflow = "initial";
  },
  components: {
    BaseModal,
    SystemsNavigator,
  },
};
</script>

<style scoped>
.help-modal {
  background: rgba(70, 70, 70, 0.5);
  backdrop-filter: blur(7px);

  z-index: 5000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.help-content {
  text-align: center;
  align-content: center;
  align-items: center;
}

.help-image {
  width: 125vh;
  margin-top: 5vh;
}

.help-text {
  font-size: 2.2vh;
}

.help-controls {
  display: flex;
  justify-content: center;
  justify-items: center;
  margin-top: 2.65vh;
}

#gatewayHelpImages {
  display: flex;
  overflow: scroll;

  padding: 0 30vh;
}


.left-spacer {
    min-width: 30vh;
    min-height: 10vh;
}

.help-image-current {
    transform: scale(1.06);
}

.close-icon {
    position: absolute;
    top: 2.15vh;
    right: 2.15vh;
    cursor: pointer;
    z-index: 5001;
}
</style>